<template>
<div class="component" v-if="surveyData!=undefined">
    <h1 class="title">{{surveyData.title}}</h1>

    <div class="columns is-mobile is-multiline">
        <div class="has-text-left column is-6	">
            <span class="button is-danger addQuestion" @click="$emit('close')">Zurück</span>
        </div>
        <div class="has-text-right column is-6	"> <span class="button is-info addQuestion" @click="addQuestion=true">Frage hinzufügen</span>

        </div>

    </div>

    <div class="card" v-for="question in surveyData.questions">
        <header class="card-header" @click="choosenQuestion = question">
            <p class="card-header-title">
                {{question.question}}
            </p>
            <a href="#" class="card-header-icon" aria-label="more options">
                <span v-if="question.questionType==0">{{question.answers.length}} mögliche Antworten</span>
                <span v-else="question.questionType==0">Keine Antwortvorgaben</span>

            </a>
        </header>
        <div class="card-content" v-if="choosenQuestion.id == question.id && question.questionType==0">
            <div class="content">
                <div class="list is-hoverable">
                    <a class="list-item" v-for="answer in question.answers" @click="chooseSurvey(survey.id)">
                        {{answer.answerText}}
                    </a>
                </div>
                <span class="button" @click="addAnswerModal=true" >Antwort hinzufügen</span>

            </div>
        </div>
        <footer class="card-footer">
        </footer>
    </div>

    <div v-if="addAnswerModal">
        <addAnswer @close="addAnswerModal=false" :question="choosenQuestion"  @onAnswerAdd="getSurvey()"></addAnswer>
    </div>

    <div v-if="addQuestion">
        <addQuestion :surveyId="surveyId" @close="addQuestion=false" @onQuestionAdd="getSurvey()"></addQuestion>
    </div>

</div>
</template>

<script>
import addAnswer from '@/components/Surveys/addPossibleAnswer.vue'
import addQuestion from '@/components/Surveys/addQuestion.vue'

export default {
    name: 'showSurvey',
    props: ["surveyId"],
    components: {
        addAnswer,
        addQuestion
    },
    mounted: function () {
        this.getSurvey();
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            surveyData: null,
            choosenQuestion: -1,
            addAnswerModal: false,
            addQuestion: false,
        }
    },
    methods: {
        getSurvey() {

            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            this.$axios.get(this.$backendURL + "/survey/" + this.surveyId, {
                headers: headerData
            }).then(function (response) {

                this.surveyData = response.data.survey[0]
            }.bind(this))

        },

        addAnswer() {

        }
    },
    computed: {},
}
</script>

<style scoped>
.title {
    margin-top: 20px;
}

.addQuestion {
    font-size: 22px !important;
    margin: 20px 0%;
    font-weight: bolder;
}
</style>
